import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { AssessorAjEventApproval } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'

export default class AssessorApprovalModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string
  }

  render() {
    const { colorClass, modalId } = this.props

    return (
      <MaterialModal.Body id={modalId} colorClass={colorClass} narrow noHeader>
        <MaterialModal.Content noHeader noFooter>
          <AssessorAjEventApproval {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
